import React from 'react';
import { Puff } from 'react-loader-spinner';

import { remCss, scssVariables as variables, lang } from 'src/helpers';

const LoadMore = React.memo(
  ({
    loading = false,
    onClick,
    justifyContent = 'center',
    color,
    size = 20,
    containerStyles = {}
  }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexGrow: 1,
        cursor: 'pointer',
        ...containerStyles
      }}
      onClick={onClick}
    >
      <div
        className={'mc-flex'}
        style={{
          justifyContent,
          backgroundColor: color || variables['colors-mc-primary'],
          color: '#fff',
          padding: remCss(10),
          width: remCss(150),
          borderRadius: remCss(5)
        }}
      >
        {loading && <Puff color={'#fff'} height={remCss(size)} width={remCss(size)} />}
        {loading ? lang.t('Loading') + '...' : lang.t('Load More')}
      </div>
    </div>
  )
);


LoadMore.displayName = 'LoadMore';

export default LoadMore;
